import { render } from "./FirstPage.vue?vue&type=template&id=504efc9e&scoped=true"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"

import "./FirstPage.vue?vue&type=style&index=0&id=504efc9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504efc9e"]])

export default __exports__